// Returns the internal redirect URL that logs a ShopClick and forwards to the
// shop's listing page with ?ref=boardo appended. All "Buy →" / shop-card hrefs
// in the UI should go through this so we own the click data.
export function shopClickUrl(shopListingId: string | number): string {
  return `/out/shop/${shopListingId}`;
}
